import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCallback, useEffect } from 'react'

export interface PersonOrganization {
  id: number
  organizationId: number
  organizationName: string
  personId: number
  status: string
  lastActivityAt?: Date
  addedAt?: Date
  updatedAt?: Date
}

export const useGetOrganizationStatuses = (): [
  (personId: number) => Promise<PersonOrganization[]>,
  Status<PersonOrganization[]>,
] => {
  const [request, status] = useFetchRefactored<PersonOrganization[]>({ emptyValue: [] })

  const getOrgStatuses = useCallback(
    async (personId: number): Promise<PersonOrganization[]> =>
      request({
        method: 'get',
        url: `/people/${personId}/organization_statuses`,
      }),
    [request],
  )

  return [getOrgStatuses, status]
}

export const useOrganizationStatuses = (personId: number) => {
  const [getStatuses, { loading, called, result: organizationStatuses }] = useGetOrganizationStatuses()

  useEffect(() => {
    getStatuses(personId)
  }, [getStatuses, personId])

  return { organizationStatuses, loading: !called || loading }
}
